import { ChannelApplicationsListModule } from '@/components/modules/ChannelDetail/ChannelApplicationsList';
import { ChannelDetailsModule } from '@/components/modules/ChannelDetail/ChannelDetails/ChannelDetails';
import { ChannelUserListModule } from '@/components/modules/ChannelDetail/ChannelUserList';
import { MerchantStructureModule } from '@/components/modules/MerchantDetail/MerchantStructure/MerchantStructure';
import { MetricChannelViewsModule } from '@/components/modules/Metrics/ChannelAgentMetricViews/MetricChannelViews';
import { PAGE_CHANNEL_ALLOWED_ROLES } from '@/components/views/DynamicPageView/config/layoutScheme/constants/PageChannelAllowedRoles';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_CHANNEL: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.CHANNEL,
  schemesByRoles: [
    {
      roles: PAGE_CHANNEL_ALLOWED_ROLES,
      titleTextId: 'CHANNEL',
      widgets: [
        {
          id: WIDGETS.CHANNEL_PAGE_TITLE,
          props: {},
          roles: PAGE_CHANNEL_ALLOWED_ROLES,
          notShownInRightMenu: true,
        },
        { id: WIDGETS.CHANNEL_DETAILS_ACTIONS_WIDGET, props: {}, roles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN] },
      ],
    },
  ],
  sections: [
    {
      textId: 'CHANNEL_DETAILS',
      module: (
        <ChannelDetailsModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.MERCHANT_GROUP,
            ],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN], //TODO add editModeAllowed when request is ready in js-api-client
          }}
        />
      ),
    },
    {
      textId: 'CHANNEL_STRUCTURE',
      module: (
        <MerchantStructureModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.MERCHANT_GROUP,
            ],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
          }}
          hideChannelList
        />
      ),
    },
    {
      textId: 'CHANNEL_METRICS',
      module: (
        <MetricChannelViewsModule
          permissions={{
            view: [APP_USER_TYPES.MERCHANT, APP_USER_TYPES.MERCHANT_GROUP],
          }}
        />
      ),
    },
    {
      textId: 'USER_CREDENTIALS',
      module: (
        <ChannelUserListModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.MERCHANT_GROUP,
            ],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
          }}
        />
      ),
    },
    {
      textId: 'APPLICATIONS_LIST',
      module: (
        <ChannelApplicationsListModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.MERCHANT,
              APP_USER_TYPES.MERCHANT_GROUP,
            ],
          }}
        />
      ),
    },
  ],
};
